import React from 'react';
import { LazyLottie } from '../LazyLottie';

interface ILoaderMilkCanProps {
  isLoading: boolean;
  isCo2Loader?: boolean;
}

const LoaderMilkCan = (props: ILoaderMilkCanProps) => {
  const { isLoading, isCo2Loader } = props;

  return <LazyLottie
    getAnimationData={() => isCo2Loader ? import('@assets/json-lottie/co2-loader.json') : import('@assets/json-lottie/milk-loader.json')}
    loop
    id='empty-box'
    style={{ height: 250, width: 250 }}
  />
};

export default LoaderMilkCan;
